import React from 'react';
import PlusLogoWhiteSvg from '../../../../assets/images/views/pages/first_specific_cp2607/plus-logo-white.svg';
import type { ProjectsPr } from '../../models/projects/pr';

interface Props {
  pr: ProjectsPr;
}

// 案件一覧に差し込むFUNDINNO PLUS+（非公開案件のご案内）のPRカード。
// 表示判定とリンク先はサーバ側（/api/v1/projects/pr）が返す
export default function PrCard({ pr }: Props) {
  return (
    <div className="col-md-6 mb-30">
      <a className="projects card pr-card" href={pr.linkUrl}>
        <div className="pr-card-visual">
          <img
            className="pr-card-logo"
            src={PlusLogoWhiteSvg}
            alt="FUNDINNO PLUS+"
            width="272"
            height="26"
          />
          <div className="pr-card-visual-text">非公開案件のご案内</div>
        </div>
        <div className="pr-card-badge">限定オファー</div>
        <div className="card-body">
          <div className="pr-card-content">
            <div className="pr-card-heading">
              ご登録情報に基づき、
              <span className="pr-card-heading-em">非公開案件</span>
              を限定公開しています
            </div>
            <div className="pr-card-description">
              FUNDINNO
              PLUS+ではIPOを目指すミドル・レイターステージの企業の案件を限定公開しています。
            </div>
            <div className="pr-card-note">
              ※この案件情報は、
              <span className="pr-card-note-em">
                ご登録の資産・年収・ご職歴からサービスをご利用いただける可能性がある方
              </span>
              にのみ、限定してご案内しております。
            </div>
            <div className="pr-card-link">
              案件詳細はこちら
              <i className="fas fa-chevron-right pr-card-link-icon" />
            </div>
          </div>
          <div className="pr-card-footer">
            <div className="pr-card-footer-inner">
              ※お申し込みには特定投資家への移行が必要です。特定投資家移行のお手続きはマイページから最短5分でWEBで完結します。
            </div>
          </div>
        </div>
      </a>
    </div>
  );
}
